(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-custom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ROOT_SELECTOR = '[data-jpt-product-custom]';

    function initAll(scope) {
      var container = scope || document;
      var roots = [];

      if (container.matches && container.matches(ROOT_SELECTOR)) {
        roots.push(container);
      }

      if (container.querySelectorAll) {
        Array.prototype.push.apply(roots, container.querySelectorAll(ROOT_SELECTOR));
      }

      roots.forEach(initProductSection);
    }

    function initProductSection(root) {
      if (!root || root.dataset.jptProductInitialized === 'true') return;
      root.dataset.jptProductInitialized = 'true';

      var controller = 'AbortController' in window ? new AbortController() : null;
      var signal = controller ? controller.signal : undefined;
      var cleanups = [];

      function on(element, type, handler, options) {
        if (!element) return;
        var opts = options || {};
        if (signal) opts.signal = signal;
        element.addEventListener(type, handler, opts);
      }

      function addCleanup(fn) {
        cleanups.push(fn);
      }

      initBuyNow(root, on);
      initOfferCarousel(root, on, addCleanup);
      initCodTooltip(root, on);
      initReviews(root, on, addCleanup);
      initDescriptionVideos(root, on);

      root.jptProductCleanup = function () {
        if (controller) controller.abort();
        cleanups.forEach(function (fn) {
          try { fn(); } catch (error) { /* no-op cleanup */ }
        });
        cleanups.length = 0;
        delete root.dataset.jptProductInitialized;
        delete root.jptProductCleanup;
      };
    }

    function initBuyNow(root, on) {
      var button = root.querySelector('[data-buy-now]');
      var form = root.querySelector('[data-product-purchase-form]');
      var status = root.querySelector('[data-buy-now-status]');

      if (!button || !form || button.disabled) return;

      on(button, 'click', async function () {
        var variantInput = form.querySelector('input[name="id"]');
        var quantityInput = form.querySelector('input[name="quantity"]');
        var variantId = variantInput ? parseInt(variantInput.value, 10) : 0;
        var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

        if (!variantId) return;
        if (!quantity || quantity < 1) quantity = 1;

        var originalText = button.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Please wait...';
        if (status) status.textContent = '';

        try {
          var response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: quantity }]
            })
          });

          var payload = null;
          try { payload = await response.json(); } catch (error) { payload = null; }

          if (!response.ok) {
            var message = payload && (payload.description || payload.message)
              ? (payload.description || payload.message)
              : 'Unable to add this product right now.';
            throw new Error(message);
          }

          window.location.assign(root.dataset.checkoutUrl || '/checkout');
        } catch (error) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = originalText;
          if (status) status.textContent = error && error.message ? error.message : 'Please try again.';
        }
      });
    }

    function initOfferCarousel(root, on, addCleanup) {
      var carousel = root.querySelector('[data-jpt-offer-carousel]');
      if (!carousel) return;

      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-offer-slide]'));
      var nextButton = carousel.querySelector('[data-offer-next]');
      var progress = carousel.querySelector('[data-offer-progress]');
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));
      var timer = null;
      var duration = 4000;

      if (slides.length < 2) return;

      function render(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        restartProgress();
      }

      function restartProgress() {
        if (!progress || reducedMotion) return;
        carousel.classList.remove('is-running');
        progress.getBoundingClientRect();
        carousel.classList.add('is-running');
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
        carousel.classList.remove('is-running');
      }

      function start() {
        stop();
        if (reducedMotion || document.hidden) return;
        if (carousel.matches(':hover') || carousel.contains(document.activeElement)) return;
        restartProgress();
        timer = window.setInterval(function () { render(index + 1); }, duration);
      }

      function manualNext() {
        render(index + 1);
        start();
      }

      on(nextButton, 'click', manualNext);
      on(carousel, 'mouseenter', stop);
      on(carousel, 'mouseleave', start);
      on(carousel, 'focusin', stop);
      on(carousel, 'focusout', function () {
        window.setTimeout(function () {
          if (!carousel.contains(document.activeElement)) start();
        }, 0);
      });
      on(document, 'visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      addCleanup(stop);
      start();
    }

    function initCodTooltip(root, on) {
      var trigger = root.querySelector('[data-cod-trigger]');
      var tooltip = root.querySelector('[data-cod-tooltip]');
      if (!trigger || !tooltip) return;

      var pinned = false;

      function positionTooltip() {
        if (tooltip.hidden) return;

        var rect = trigger.getBoundingClientRect();
        var tipRect = tooltip.getBoundingClientRect();
        var gap = 8;
        var viewportWidth = document.documentElement.clientWidth;
        var viewportHeight = window.innerHeight;

        var left = rect.right - tipRect.width;
        left = Math.max(gap, Math.min(left, viewportWidth - tipRect.width - gap));

        var top = rect.top - tipRect.height - gap;
        if (top < gap) top = rect.bottom + gap;
        top = Math.max(gap, Math.min(top, viewportHeight - tipRect.height - gap));

        tooltip.style.left = left + 'px';
        tooltip.style.top = top + 'px';
      }

      function openTooltip() {
        tooltip.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        positionTooltip();
      }

      function closeTooltip() {
        tooltip.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        pinned = false;
      }

      on(trigger, 'click', function (event) {
        event.stopPropagation();
        if (!tooltip.hidden && pinned) {
          closeTooltip();
          return;
        }
        pinned = true;
        openTooltip();
      });

      on(trigger, 'mouseenter', openTooltip);
      on(trigger, 'mouseleave', function () { if (!pinned) closeTooltip(); });
      on(trigger, 'focus', openTooltip);
      on(trigger, 'blur', function () { if (!pinned) closeTooltip(); });

      on(document, 'click', function (event) {
        if (!tooltip.hidden && event.target !== trigger && !tooltip.contains(event.target)) closeTooltip();
      });

      on(document, 'keydown', function (event) {
        if (event.key === 'Escape' && !tooltip.hidden) {
          closeTooltip();
          trigger.focus();
        }
      });

      on(window, 'resize', positionTooltip);
      on(window, 'scroll', positionTooltip, { passive: true });
    }

    function initReviews(root, on, addCleanup) {
      var reviewsRoot = root.querySelector('[data-jpt-reviews]');
      if (!reviewsRoot) return;

      var count = parseInt(reviewsRoot.dataset.reviewCount || '0', 10) || 0;
      if (count <= 0) return;

      var widget = reviewsRoot.querySelector('ryviu-widget');
      var shell = reviewsRoot.querySelector('[data-review-shell]');
      var target = reviewsRoot.querySelector('[data-review-target]');
      var prevButton = reviewsRoot.querySelector('[data-review-prev]');
      var nextButton = reviewsRoot.querySelector('[data-review-next]');
      var dialog = root.querySelector('[data-review-dialog]');
      var dialogImage = dialog ? dialog.querySelector('[data-review-dialog-image]') : null;
      var dialogClose = dialog ? dialog.querySelector('[data-review-dialog-close]') : null;

      if (!widget || !target || !shell) return;

      var observer = null;
      var timeout = null;
      var cards = [];
      var current = 0;
      var finished = false;

      function cleanText(element) {
        if (!element) return '';
        var clone = element.cloneNode(true);
        var junkSelectors = [
          '[class*="helpful" i]',
          '[class*="report" i]',
          '[class*="vote" i]',
          '[class*="action" i]',
          'button'
        ];

        junkSelectors.forEach(function (selector) {
          clone.querySelectorAll(selector).forEach(function (node) { node.remove(); });
        });

        return (clone.innerText || clone.textContent || '').trim();
      }

      function extractRating(item) {
        var ratingNode = item.querySelector('[data-rating], [aria-label*="star" i], [title*="star" i], [class*="rating" i]');
        if (ratingNode) {
          var candidates = [
            ratingNode.getAttribute('data-rating'),
            ratingNode.getAttribute('aria-label'),
            ratingNode.getAttribute('title')
          ];
          for (var i = 0; i < candidates.length; i++) {
            var match = String(candidates[i] || '').match(/([1-5](?:\.\d+)?)/);
            if (match) return Math.min(5, Math.max(1, parseFloat(match[1])));
          }
        }

        var starWrap = item.querySelector('[class*="stars" i], [class*="rating" i]');
        if (!starWrap) return null;

        var total = starWrap.querySelectorAll('svg, [class*="star" i]').length;
        var empty = starWrap.querySelectorAll('[class*="stbk" i], [class*="empty" i], [fill="none"]').length;
        if (!total) return null;

        return Math.min(5, Math.max(1, total - empty));
      }

      function extractReviews() {
        var selectors = [
          '.r--carousel-item',
          '.Ryviu-Content-Item',
          '[class*="review-item" i]',
          '[class*="review_item" i]'
        ];
        var items = [];

        for (var i = 0; i < selectors.length; i++) {
          var found = widget.querySelectorAll(selectors[i]);
          if (found.length) {
            items = Array.prototype.slice.call(found);
            break;
          }
        }

        if (!items.length) return [];

        var seen = new Set();
        var results = [];

        items.some(function (item) {
          var authorNode = item.querySelector('[class*="author-name" i], [class*="author_name" i], [class*="authorname" i]');
          var bodyNode = item.querySelector('[class*="content-review" i], [class*="review-body" i], [class*="reviewbody" i], [class*="title-review" i]');
          var author = authorNode ? (authorNode.innerText || authorNode.textContent || '').trim() : 'Customer';
          var body = cleanText(bodyNode);
          var rating = extractRating(item);
          var verified = !!item.querySelector('[class*="verified" i], [title*="verified" i], [aria-label*="verified" i]');
          var photoSrc = '';

          var image = item.querySelector('[class*="Cover-Image" i] img, [class*="cover-image" i] img, [class*="photo" i] img');
          if (image) {
            photoSrc = image.getAttribute('data-src') || image.getAttribute('data-lazy') || image.currentSrc || image.src || '';
          }

          if (!photoSrc) {
            var backgroundImage = item.querySelector('[style*="background-image"]');
            if (backgroundImage) {
              var bgMatch = backgroundImage.style.backgroundImage.match(/url\(["']?(.*?)["']?\)/);
              if (bgMatch && bgMatch[1]) photoSrc = bgMatch[1];
            }
          }

          if (photoSrc && (photoSrc.indexOf('placeholder') !== -1 || photoSrc.length < 10)) photoSrc = '';
          if (!author || author.length > 80) author = 'Customer';

          var key = author + '|' + body.slice(0, 80);
          if (seen.has(key)) return false;
          seen.add(key);

          if (body || photoSrc || rating) {
            results.push({
              author: author,
              body: body,
              rating: rating,
              verified: verified,
              photoSrc: photoSrc
            });
          }

          return false;
        });

        return results;
      }

      function createStar(filled) {
        var ns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(ns, 'svg');
        var path = document.createElementNS(ns, 'path');
        svg.setAttribute('width', '13');
        svg.setAttribute('height', '13');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('aria-hidden', 'true');
        path.setAttribute('d', 'M12 17.27 18.18 21 16.54 13.97 22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z');
        path.setAttribute('fill', filled ? '#F9A01B' : '#E5E5E5');
        svg.appendChild(path);
        return svg;
      }

      function openDialog(src, author) {
        if (!dialog || !dialogImage || !src) return;
        dialogImage.src = src;
        dialogImage.alt = author ? 'Review photo by ' + author : 'Customer review photo';
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      }

      function buildCards(reviews) {
        target.textContent = '';
        cards = [];
        var fragment = document.createDocumentFragment();

        reviews.forEach(function (review, index) {
          var card = document.createElement('article');
          card.className = 'jpt-review-card';
          card.hidden = index !== 0;

          if (review.photoSrc) {
            var photoButton = document.createElement('button');
            photoButton.type = 'button';
            photoButton.className = 'jpt-review-photo';
            photoButton.setAttribute('aria-label', 'Open review photo by ' + review.author);

            var photo = document.createElement('img');
            photo.src = review.photoSrc;
            photo.alt = 'Review photo by ' + review.author;
            photo.loading = 'lazy';
            photo.width = 68;
            photo.height = 68;
            photoButton.appendChild(photo);
            photoButton.addEventListener('click', function () { openDialog(review.photoSrc, review.author); });
            card.appendChild(photoButton);
          }

          var body = document.createElement('div');
          body.className = 'jpt-review-body';

          var top = document.createElement('div');
          top.className = 'jpt-review-top';

          var author = document.createElement('p');
          author.className = 'jpt-review-author';
          author.textContent = review.author;
          top.appendChild(author);

          if (review.verified) {
            var verified = document.createElement('span');
            verified.className = 'jpt-review-verified';
            verified.textContent = '✓ Verified';
            top.appendChild(verified);
          }

          body.appendChild(top);

          if (review.rating) {
            var stars = document.createElement('div');
            stars.className = 'jpt-review-stars';
            stars.setAttribute('aria-label', review.rating + ' out of 5 stars');
            for (var i = 1; i <= 5; i++) stars.appendChild(createStar(i <= Math.round(review.rating)));
            body.appendChild(stars);
          }

          if (review.body) {
            var text = document.createElement('p');
            text.className = 'jpt-review-text';
            text.textContent = review.body;
            body.appendChild(text);
          }

          card.appendChild(body);
          fragment.appendChild(card);
          cards.push(card);
        });

        target.appendChild(fragment);
        shell.setAttribute('aria-busy', 'false');
        current = 0;
        syncNavigation();
      }

      function showFallback() {
        if (finished) return;
        finished = true;
        if (observer) observer.disconnect();
        if (timeout) window.clearTimeout(timeout);

        var rating = parseFloat(reviewsRoot.dataset.reviewRating || '0') || 0;
        var total = parseInt(reviewsRoot.dataset.reviewCount || '0', 10) || 0;
        target.textContent = '';

        var fallback = document.createElement('div');
        fallback.className = 'jpt-review-fallback';

        var strong = document.createElement('strong');
        strong.textContent = rating > 0 ? rating.toFixed(1) + ' / 5' : 'Customer reviews';
        fallback.appendChild(strong);

        var copy = document.createElement('span');
        copy.textContent = total > 0 ? 'Based on ' + total + ' customer reviews.' : 'Reviews are temporarily unavailable.';
        fallback.appendChild(copy);

        target.appendChild(fallback);
        shell.setAttribute('aria-busy', 'false');
      }

      function syncNavigation() {
        if (!prevButton || !nextButton) return;
        var multiple = cards.length > 1;
        prevButton.hidden = !multiple || current === 0;
        nextButton.hidden = !multiple || current === cards.length - 1;
      }

      function showCard(nextIndex) {
        if (!cards.length || nextIndex < 0 || nextIndex >= cards.length) return;
        cards[current].hidden = true;
        current = nextIndex;
        cards[current].hidden = false;
        syncNavigation();
      }

      function tryExtract() {
        if (finished) return;
        var reviews = extractReviews();
        if (!reviews.length) return;

        finished = true;
        if (observer) observer.disconnect();
        if (timeout) window.clearTimeout(timeout);
        buildCards(reviews);
      }

      on(prevButton, 'click', function () { showCard(current - 1); });
      on(nextButton, 'click', function () { showCard(current + 1); });

      if (dialog) {
        on(dialogClose, 'click', function () { dialog.close(); });
        on(dialog, 'click', function (event) {
          if (event.target === dialog) dialog.close();
        });
        on(dialog, 'close', function () {
          if (dialogImage) {
            dialogImage.removeAttribute('src');
            dialogImage.alt = '';
          }
        });
      }

      observer = new MutationObserver(tryExtract);
      observer.observe(widget, { childList: true, subtree: true });
      timeout = window.setTimeout(showFallback, 7000);
      addCleanup(function () {
        if (observer) observer.disconnect();
        if (timeout) window.clearTimeout(timeout);
      });

      tryExtract();
    }

    function initDescriptionVideos(root, on) {
      var descriptionRoot = root.querySelector('[data-description-root]');
      if (!descriptionRoot) return;

      function getYouTubeId(rawUrl) {
        try {
          var url = new URL(rawUrl, window.location.origin);
          var host = url.hostname.replace(/^www\./, '').toLowerCase();

          if (host === 'youtu.be') return url.pathname.split('/').filter(Boolean)[0] || '';
          if (host !== 'youtube.com' && host !== 'm.youtube.com') return '';

          if (url.pathname === '/watch') return url.searchParams.get('v') || '';

          var parts = url.pathname.split('/').filter(Boolean);
          if ((parts[0] === 'shorts' || parts[0] === 'embed') && parts[1]) return parts[1];
        } catch (error) {
          return '';
        }
        return '';
      }

      function enhance(container) {
        if (!container) return;
        container.querySelectorAll('a[href*="youtube.com"], a[href*="youtu.be"]').forEach(function (link) {
          if (link.dataset.jptYoutubeEnhanced === 'true') return;

          var videoId = getYouTubeId(link.href);
          if (!videoId) return;
          link.dataset.jptYoutubeEnhanced = 'true';

          var wrapper = document.createElement('div');
          wrapper.className = 'jpt-youtube-embed';

          var iframe = document.createElement('iframe');
          iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId);
          iframe.title = (link.textContent || '').trim() || 'Product video';
          iframe.loading = 'lazy';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          wrapper.appendChild(iframe);

          var parent = link.closest('p');
          (parent || link).replaceWith(wrapper);
        });
      }

      descriptionRoot.querySelectorAll('[data-description-content]').forEach(function (content) {
        var details = content.closest('details');
        if (!details || details.open) enhance(content);
      });

      descriptionRoot.querySelectorAll('details').forEach(function (details) {
        on(details, 'toggle', function () {
          if (details.open) enhance(details.querySelector('[data-description-content]'));
        });
      });
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (!event.target || !event.target.querySelectorAll) return;
      event.target.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
        if (typeof root.jptProductCleanup === 'function') root.jptProductCleanup();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
